import leadlgIcon from 'assets/images/account-page/lead-auto-lg-img.svg';
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import currencyFormat from 'utils/currency/numberToPrice';
import numberFormat from 'utils/number/format';
import { selectLeadAutomator, selectPlanDetails, updateSelectedLeadAutomator } from '../../../data/user';
import css from '../style.scss';
import { connect } from "react-redux";
import LeaveMessagePopup from "../modals/LeaveMessage";


const LeadAutomatorScreen = (props) => {
  const leadAutomatorInfo = useSelector(selectLeadAutomator)?.toJS();

  const [plans, setPlans] = useState([]);

  const dispatch = useDispatch();
  const planDetails = useSelector(selectPlanDetails)?.toJS();

  useEffect(() => {
    if (leadAutomatorInfo?.planMrcs && leadAutomatorInfo?.planMrcs.length > 0 
      && leadAutomatorInfo?.planMrcs.length !== plans.length) {
      setPlans(leadAutomatorInfo?.planMrcs);
    }
  }, [leadAutomatorInfo?.planMrcs]);

  const goToManageLeadAutomator = (type) => {
    if (type === 'unsubscribe') {
      dispatch(updateSelectedLeadAutomator(null));
    }
    if ((!leadAutomatorInfo?.selectedLead || !leadAutomatorInfo?.selectedLead?.id) && type !== 'unsubscribe') {
      props.leaveMessagePopup({
        title: "Please select a plan",
        message: "Please select a plan to continue",
        cancelLable: '',
        yesLable: 'Close',
      });
      return;
    }
    props.history.push(`/accountnew/manageleadautomator/${type}`);
  };

  const goToAccount = () => {
    props.leaveMessagePopup({
      title: "Are you sure want to leave?",
      message: "Please press yes to leave the page, no to stay on the page",
      cancelLable: 'No',
      yesLable: 'Yes',
      yesRedirect: () => {
        props.history.push(`/accountnew/landing`);
      },
    });
  }
  

  const getPlanName = () => {
    if (planDetails?.accountEnrolledPlans && planDetails?.accountEnrolledPlans.length > 0) {
      const selectedPlan = planDetails.availableUserPlans.find(plan => plan.id === planDetails?.accountEnrolledPlans[0]?.planId);
      if (selectedPlan && selectedPlan?.name) return selectedPlan.name.split(' ')[0];
      return "";
    }
    return "";
  }
  return (
    <>
      <div className={css.clsInnerMainBody}>
        <div className={classNames("d-flex align-items-center")}>
          <div className="container">
            <div className={classNames(css.clsLeamAutoMainSec,"align-items-center","d-flex")} style={{"min-height": "calc(100vh - 100px)"}}>
              <div className="row justify-content-center" style={{"padding-bottom": '13rem'}}>
                <div className="col-lg-5">
                  <div className={css.clsLAMainLeft}>
                    <h2 className={css.clsLAMainHeading}>Lead Automator</h2>
                    <div className={css.clsLAImgLarge}>
                      <img src={leadlgIcon} alt="leadlgIcon" />
                    </div>
                    <div className={css.clsLAMainPara}>
                      <p>Say goodbye to manual list management and hello to automated accuracy! Activate Lead Automator on your marketing lists, and watch as new properties are added and old leads are removed automatically.</p>
                      <p>Add Lead Automator today and get FREE skip tracing on the {getPlanName()} Plan for primary account holders and—just 10¢ per contact for additional users! Plus, send postcards for as low as 48¢ each!</p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className={css.clsLAMainRight}>
                    <ul className={css.clsLASubscribeList}>

                      {plans.length > 0 && plans.map((plan) => (
                        <li
                          key={plan.id}
                          className={`${css.clsLASubscribeItem} ${plan.quantity === leadAutomatorInfo?.monitoredProperties ? css.disableLeadautomator : ''}`}
                          onClick={() => {
                            if(plan.quantity !== leadAutomatorInfo?.monitoredProperties)
                              dispatch(updateSelectedLeadAutomator(plan));
                          }}
                        >
                          <a href="javascript:;"
                            className={`${css.clsLASubscribeLink} ${ 
                              leadAutomatorInfo?.selectedLead?.id === plan.id ? css.selected : ""}`}>
                            <div className={css.clsLASubscribeLeftTxt}>
                              <h4 className={css.clsLASubscribeTxt1}>{numberFormat(plan.quantity)}</h4>
                              <p className={css.clsLASubscribeTxt2}>Monitored Properties</p>
                            </div>
                            {plan.id === leadAutomatorInfo?.accountPlanMrcs[0]?.id && <div className={css.clsLASubscribeBtn}>
                              <button className={classNames(css.btn_primary, css.clsBtnPrimaryGreen)}> Current Plan</button>
                            </div>}

                            <div className={css.clsLASubscribeRightTxt}>
                              <h4 className={css.clsLASubscribeTxt1}>{currencyFormat(plan.amount)}<sub>/mo</sub></h4>
                            </div>
                          </a>


                        </li>
                      ))}


                    </ul>

                    <div className="d-flex justify-content-center">
                      {leadAutomatorInfo?.monitoredProperties > 0 && <p className={css.clsLAUnSubscribeTxt}  onClick={() => goToManageLeadAutomator('unsubscribe')}>Unsubscribe from Lead Automator</p>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css.clsInnerFooter}>
          <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnPrimaryGreen)} onClick={() => goToAccount()}> Cancel</button>
          <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)} 
            disabled={planDetails?.usedLATrial && leadAutomatorInfo?.accountPlanMrcs && leadAutomatorInfo?.accountPlanMrcs?.length > 0 && leadAutomatorInfo?.accountPlanMrcs[0]?.planType === "Trial Plan Promo"} 
            onClick={() => goToManageLeadAutomator('review')}> Continue</button>
        </div>
      </div>


    </>
  );
};


export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open,
  leaveMessagePopupClose: LeaveMessagePopup.close
})(LeadAutomatorScreen));
